import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { FormattedMessage } from "react-intl";

/**
 * Label:
 *  - Label for Menu in Notebook/MenuList
 */
export function Label(props) {
  const className = `${style.label} ${props.className}`;

  return (
    <div className={className}>
      <FormattedMessage id={props.title} defaultMessage={props.title} />
    </div>
  );
}

Label.propTypes = {
  /**
   * Menu Title
   */
  title: PropTypes.string,
};

Label.defaultProps = {
  title: "",
};
